import React from 'react'
export const HelpScout = React.createContext({
  helpScoutLoading: false,
  setHelpScoutLoading: (val) => {},
  helpScoutLoaded: false,
  setHelpScoutLoaded: (val) => {}
})
